(function($) {
	//Don't need to load in the Admin (it's better to show the Title and its content since you can't click)
	$('div.gallery').each(function() {
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1]
			}
		});
	});
  
    $('.video-modal').magnificPopup({
      delegate: 'a',
      type: 'iframe',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1]
      }
    });

  
})(jQuery);